import React, {useState, useMemo, useCallback} from "react";
import { Input } from "../../ui/Input";
import { SelectCountry } from "../../selectors/country/selectCountry";
import { SelectCompanyType } from "../../selectors/companyType/selectCompanyType";
import { SelectRegulatoryBody } from "../../selectors/regulatoryBody/selectRegulatoryBody";
import useDeligenceStatus from "../../../hooks/useDeligenceStatus";
import { diligenceObservable } from "../../../observers/deligenceObservable";
import { CountryRiskPopup } from "../../popups/countryRiskPopup";
export const RegulatedEntityForm = React.memo(({renderBy, index, formData, onChange, isReadOnly, isReport}) => {

    const { getDeligenceStatusByCountry } = useDeligenceStatus();
    const ownerId = useMemo(()=>{ return renderBy + index.toString() + "RegulatedEntity"}, [index, renderBy]);
    const [showPopup, setShowPopup] = useState(false);

    const handleCountryChange = useCallback(async (event) => {
                    diligenceObservable.remove(ownerId);
                    const selectedCountry = event.target.value;
                    const name = event.target.name;
                    if (selectedCountry !== "None") {
                        const response = await getDeligenceStatusByCountry(selectedCountry);
                        if (response) {
                            const hasEnhanced = response.some((item) => item.Diligence.toLowerCase() === "enhanced");
                            if (hasEnhanced) {
                                setShowPopup(true);   
                            }
                        }
                    }
                    let privateEvent = { target: { name: name, value: selectedCountry } };
                    onChange(privateEvent);
                }, [getDeligenceStatusByCountry, onChange, ownerId]);

    return (
        <>
            <Input
                label={"Entity Name"}
                name={"uboEntityName"}
                placeholder={"Entity Name"}
                disabled={isReadOnly}
                value={formData.uboEntityName}
                onChange={onChange}
                isReport={isReport}
                required
            />

            <SelectCountry
                label={"Country of Incorporation"}
                required={true}
                name={"uboCountry"}
                disabled={isReadOnly}
                value={formData.uboCountry}
                onChange={(e)=>{handleCountryChange(e)}}
                isReport={isReport}
            />

            <SelectCompanyType
                label={"Type of Entity"}
                name={"uboEntityType"}
                value={formData.uboEntityType}
                onChange={onChange}
                disabled={isReadOnly}
                country={formData.uboCountry}
                isReport={isReport}
                required
            />

            <SelectRegulatoryBody
                label={"Name of Regulatory Body"}
                name={"uboRegulatoryBody"}
                value={formData.uboRegulatoryBody}
                onChange={onChange}
                disabled={isReadOnly}
                country={formData.uboCountry}
                isReport={isReport}
                required
            />

            <Input 
                label={"Regulatory Reference Number"}
                name={"uboRegulatoryReferenceNumber"}
                value={formData.uboRegulatoryReferenceNumber}
                placeholder={"Entity Registration Number"}
                onChange={onChange}
                disabled={isReadOnly}
                isReport={isReport}
            />
            {showPopup && diligenceObservable.isEnhanced() === false && <CountryRiskPopup ownerId={ownerId} openPopup={true}/>}
            {/* {showPopup && diligenceObservable.isEnhanced() === true && <AlreadyEnhancedPopup openPopup={true}/>} */}
        </>
    );
});